import { css } from 'styled-components';
import { colors } from '../colors/colors';
import { complementaryColors } from '../colors/complementary-colors';
import { commonTheme } from './common-theme';
import { InputTags } from './class-name-tags';
export const inputDarkTheme = {
    ...commonTheme,
    base: css `
    ${commonTheme.base}

    .${InputTags.iconContainer} {
      color: ${colors.warmgrey500};
    }

    .${InputTags.input} {
      border-color: ${colors.warmgrey500};
      background-color: ${colors.warmgrey800};

      &::placeholder {
        color: ${colors.warmgrey500};
      }
    }

    &.error {
      ::after {
        border-bottom-color: ${colors.red600};
      }
      .${InputTags.input} {
        outline-color: ${colors.red600};
      }
    }

    &.disabled {
      .${InputTags.input} {
        border-color: ${complementaryColors.warmgrey650};
        color: ${complementaryColors.warmgrey650};

        &::placeholder {
          color: ${complementaryColors.warmgrey650};
        }
      }

      .${InputTags.iconContainer} {
        color: ${complementaryColors.warmgrey650};
      }
    }
  `,
};
//# sourceMappingURL=dark-theme.js.map